import { loaders } from 'entities';

import { sortByProperty } from 'utils/array';
import { PackageTable } from './PackageTable';

export function ActivePackages(): JSX.Element {
  const { data, errorOrLoading } = loaders.invoice.availablePackages.use({
    defaultValue: [],

    parser: (packages) => sortByProperty(packages, ['clientName']),
  });

  return <PackageTable packages={data} loading={errorOrLoading} />;
}
